<template>
  <v-breadcrumbs :items="items">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
          :to="item.href"
          :disabled="item.disabled"
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
    <div class="card_container" >
      <div class="card_header" >
        <div>เพิ่มข้อมูลชิ้นงาน</div>
      </div>

      <v-breadcrumbs :items="items">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
              :to="item.href"
              :disabled="item.disabled"
          >
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <div class="form_card" >
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <v-text-field
              v-model="names"
              :rules="[v => !!v || 'กรุณากรอกชื่อชิ้นงาน']"
              label="ชื่อชิ้นงาน"
              required
          ></v-text-field>

          <v-text-field
              v-model="code"
              :rules="[v => !!v || 'กรุณากรอกรหัสชิ้นงาน']"
              label="รหัสชิ้นงาน"
              required
          ></v-text-field>

          <v-textarea
              v-model="description"
              :rules="[v => !!v || 'กรุณากรอกคำอธิบาย']"
              label="คำอธิบาย"
              required
          ></v-textarea>


          <v-select
              v-model="category_id"
              :items="category_item"
              v-on:change="GetSubategory()"
              item-text="label"
              item-value="id"
              :rules="[v => !!v || 'กรุณาเลือกประเภทชิ้นงาน']"
              label="ประเภทชิ้นงาน"
              required
          ></v-select>

          <v-select
              v-model="subcategory_id"
              :items="subcategory_item"
              item-text="label"
              item-value="id"
              :rules="[v => !!v || 'กรุณาเลือกประเภทชิ้นงานย่อย']"
              label="ประเภทชิ้นงานย่อย"
              required
          ></v-select>


          <v-text-field
              v-model="stock"
              :rules="[v => !!v || 'กรุณากรอกจำนวน']"
              label="จำนวนสินค้า"
              required
              disabled
          ></v-text-field>

          <v-text-field
              v-model="min"
              :rules="[v => !!v || 'กรุณากรอกปริมาณสินค้าขั้นต่ำ']"
              label="ปริมาณสินค้าขั้นต่ำ"
              required
          ></v-text-field>

          <v-text-field
              v-model="max"
              :rules="[v => !!v || 'กรุณากรอกปริมาณสินค้าคงคลัง']"
              label="ปริมาณสินค้าคงคลัง"
              required

          ></v-text-field>

          <v-text-field
              v-model="unit"
              :rules="[v => !!v || 'กรุณากรอกหน่วยนับ']"
              label="หน่วยนับ"
              required
          ></v-text-field>

          <v-text-field
              v-model="price"
              label="ราคาสินค้า"
          ></v-text-field>

          <v-text-field
              v-model="limit"
              label="จำนวนเบิกสินค้า/วัน"
          ></v-text-field>

          <v-text-field
              v-model="position"
              label="ตำแหน่งชิ้นงาน"
              required
          ></v-text-field>

          <v-file-input
              @change="Preview_image"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="เลือก รูปชิ้นงาน"
              prepend-icon="mdi-camera"
              label="รูปชิ้นงาน"
          ></v-file-input>
          <div class="image_preview_container" >
            <img  id="image_preview" src=""  />
          </div>


          <div align="center" style="margin-top: 2rem" >
            <v-btn
                color="success"
                class="mr-4"
                @click="validate"
            >
              แก้ไข
            </v-btn>

            <v-btn
                color="error"
                class="mr-4"
                @click="reset"
            >
             ล้างค่า
            </v-btn>


          </div>

        </v-form>
      </div>

      <div class="form_card" >
      <v-data-table
          :headers="headers"
          :items="resultData"
          sort-by="calories"
          class="elevation-1"
      >
        <template v-slot:top>
        </template>
        <template v-slot:item.type="{ item }">
          {{ item.type === 1 ? "เพิ่ม" :  "เบิก" }}
        </template>
        <template v-slot:item.date="{ item }">
          {{ dateTime(item.createdAt) }}
        </template>
        <template v-slot:no-data>
          <v-btn
              color="primary"
              @click="initialize"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>
      </div>

    </div>
  </v-breadcrumbs>



</template>

<script>
import {
  AddStock,
  GetCategory,
  GetMachine,
  GetStock,
  GetSubCategory,
  SingleProduct,
  UpdateProduct,
} from "../../lib/controller";
import {baseUrl, position_amount} from "../../const/api";
import { dateTime } from "../../lib/utility";
import $ from 'jquery'

export default {
  name: "Users",
  data: () => ({
    rules: [
      value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
    ],
    machine_item:{},
    position_amount:position_amount,
    names:"",
    dateTime:dateTime,
    product_id:"",
    stock_old:"",
    code:"",
    min:"",
    max:"",
    unit:"",
    codes:"",
    limit:"",
    price:"",
    amount:0,
    machine_id:0,
    description:"",
    valid: true,
    file:"",
    machine: JSON.parse(localStorage.getItem('user')).machine_id,
    email: '',
    rfidcode: '',
    position: '',

    email_rules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],


    subcategory_id: '',
    category_id: '',
    category_item:[],
    subcategory_item:[],


    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],


    stock:"",
    select: null,
    checkbox: false,

    baseUrl:baseUrl,
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
      {
        text: 'ข้อมูลชิ้นงาน',
        disabled: false,
        href: '/Product',
      },
      {
        text: 'เพิ่มข้อมูลชิ้นงาน',
        disabled: true,
        href: '/Users',
      },
    ],
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: 'จำนวน', value: 'amount' },
      { text: 'ประเภท', value: 'type' },
      { text: 'วันที่เวลา', value: 'date' },
    ],
    desserts: [],
    editedIndex: -1,
    resultData:[],
  }),

  computed: {

  },
  watch: {

  },

  created () {
    this.initialize()
    this.Getdata()
    this.GetCategory()
    this.GetStock()
    this.GetMachines()
  },

  methods: {
    initialize () {

    },
    async GetMachines(){
      let machine = [];
      const { status , results } = await GetMachine();
      if(status === 200){

        results.data.forEach(function (result){
          console.log(result)
          machine.push({
            "label":result.title,
            "id":result.machine_number,
          })
        });
      }

      this.machine_item = machine;
      console.log(this.itemss)

    },
    validate () {
      console.log(this.file)
      if(this.$refs.form.validate()){
        this.ProductUpdate();
      }
    },
    reset () {
      this.$refs.form.reset()
      $('#image_preview').attr('src', '');
    },
    async ProductUpdate(){
      let Swal = this.$swal;

      let formData = new FormData();
      formData.append("name",this.names)
      formData.append("code",this.code)
      formData.append("amount",this.amount)
      formData.append("description",this.description)
      formData.append("subcategory_id",this.subcategory_id)
      formData.append("category_id",this.category_id)
      formData.append("position",this.position)
      formData.append("machine_id",JSON.parse(localStorage.getItem('user')).machine_id)
      formData.append("min",this.min)
      formData.append("max",this.max)
      formData.append("unit",this.unit)
      formData.append("price",this.price)
      formData.append("limit",this.limit)

      if(this.file){
        formData.append("file",this.file)
      }

      const { status , result } = await UpdateProduct(this.$route.params.id,this.machine_id,formData);



      if(this.stock < this.stock_old){

        let newStock = (parseInt(this.stock_old)-parseInt(this.stock))
        let formData = new FormData();

        formData.append("product_id",this.product_id)
        formData.append("type",2)
        formData.append("amount",parseInt(newStock))
        formData.append("codes_product",this.codes)
        formData.append("machine_id",this.machine_id)
        const { status  } = await AddStock(formData);
        if(status){
          console.log("OK")
        }

      }

      if(this.stock > this.stock_old){
        let formData = new FormData();
        let newStock = (parseInt(this.stock)-parseInt(this.stock_old))

        formData.append("product_id",this.product_id)
        formData.append("type",1)
        formData.append("amount",parseInt(newStock))
        formData.append("codes_product",this.codes)
        formData.append("machine_id",this.machine_id)

        const { status  } = await AddStock(formData);

        if(status){
          console.log("OK")
        }

      }



      if(status === 200){
        Swal({
          icon: 'success',
          title: 'Success',
        })
        this.$refs.form.reset()
        $('#image_preview').attr('src', '');
        await this.Getdata()
        await  this.GetStock()
        console.log(result)
      }

    },
    async Getdata(){

      const { status , results } = await SingleProduct(this.$route.params.id);
      if(status === 200){
        let  product = results.data[0];

        this.id = product._id;
        this.product_id = product.product_id;
        this.names = product.name;
        this.code = product.code;
        this.codes = product.codes;
        this.stock = product.stock;
        this.stock_old = product.stock;
        this.machine_id = product.machine_id;
        this.description = product.description;
        this.category_id = product.category_id;
        this.subcategory_id = product.subcategory_id;
        this.position = product.position;
        this.unit = product.unit;
        this.min = product.min;
        this.max = product.max;

        await this.GetSubategory()
        this.subcategory_id = product.subcategory_id;
        $('#image_preview').attr('src', baseUrl+'/'+product.image.path.replace('media',''));
        console.log(product)
      }

    },
    async GetCategory(){
      let category = [];
      const { status , results } = await GetCategory();
      if(status === 200){

        results.data.forEach(function (result,index){
          console.log(index)
          category.push({
            "label":result.title,
            "id":result.category_id,
          })
        });
      }

      this.category_item = category;
      console.log(this.itemss)

    },
    async GetSubategory(){

      let subcategory = [];

      const params = {
        machine:this.machine
      }

      const { status , results } = await GetSubCategory(this.category_id,params);
      if(status === 200){

        results.data.forEach(function (result,index){
          console.log(index)
          subcategory.push({
            "label":result.title,
            "id":result.sub_category_id,
          })
        });
      }

      this.subcategory_item = subcategory;


    },

    async GetStock(){

      const { status , results } = await GetStock(this.$route.params.id);
      if(status === 200){
        this.resultData = results.data;
      }



    },
    Preview_image(e) {
      if (e) {
        this.file = e;
        $('#image_preview').attr('src', URL.createObjectURL(e)); // jQuery selector
      }
    },
  },
}


</script>

<style scoped>
.card_container{
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid #EBEDF3;
  border-radius: 0.42rem;
}
.card_header{
  padding: 1.5rem 2rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #EBEDF3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form_card{
  padding:2rem;
}
.image_preview_container{
  display: flex;
  justify-content: center;
  align-items: center;
}
#image_preview{
  width: 20rem;
  text-align: center;
}
</style>
